import { z } from "zod/v4";

/** IANA zone string, e.g. "Australia/Sydney". Validated against Intl at decode. */
export const IanaTimezone = z.string().refine(
  (tz) => {
    try {
      new Intl.DateTimeFormat("en-AU", { timeZone: tz });
      return true;
    } catch {
      return false;
    }
  },
  { message: "Invalid IANA timezone" },
);
